import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  entries: [
    {
      date: '2021-01-01',
      activity: 'Deposit',
      debit: 0,
      credit: 1000,
      balance: 1000,
    },
  ],
};

export const eWalletSlice = createSlice({
  name: 'e-wallet',
  initialState,
  reducers: {
    setEntries: (state, action) => {
      state.entries = action.payload;
    },
    resetEWalletSlice: () => initialState,
  },
});

export const { setEntries, resetEWalletSlice } = eWalletSlice.actions;

export default eWalletSlice.reducer;
